import NextLink from 'next/link';

export const RouterLink = NextLink;
